import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import Button from './Button';
import styles from './ConfirmDialog.module.css';

export interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
  dataTestId?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
  children,
  dataTestId
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.confirmDialogOverlay}>
      <button
        type="button"
        className={styles.confirmDialogOverlayBackdrop}
        onClick={onCancel}
        tabIndex={-1}
        aria-hidden="true"
      />
      <div className={styles.confirmDialog} data-test-id={dataTestId}>
        <div className={styles.confirmDialogHeader}>
          <div className={styles.confirmDialogIcon}>
            <AlertTriangle size={24} />
          </div>
          <h3 className={styles.confirmDialogTitle}>{title}</h3>
          <button className={styles.confirmDialogClose} onClick={onCancel}>
            <X size={20} />
          </button>
        </div>

        <div className={styles.confirmDialogContent}>
          {message && <p className={styles.confirmDialogMessage}>{message}</p>}
          {children}
        </div>

        <div className={styles.confirmDialogFooter}>
          <Button variant="ghost" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
